import Vue from "vue";
import VueRouter from "vue-router";
import PaginaPrincipal from "../views/Home.vue";
import PaginaDeLogin from "../views/Login.vue";
import PaginaDoSgcq from "../views/Sgcq.vue";
import PaginaDashboardPrioridades from "../views/PrioridadeDashboard.vue";
import PaginaDoOrcamento from "../views/Orcamento.vue";
import PaginaDeCertificado from "../views/Certificado.vue";
import { useSgcqStore } from "@/stores/SgcqStore";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "PaginaPrincipal",
    component: PaginaPrincipal,
    meta: {
      publica: true,
    },
  },

  {
    path: "/login",
    name: "PaginaDeLogin",
    component: PaginaDeLogin,
    meta: {
      publica: true,
    },
  },

  {
    path: "/sgcq",
    name: "PaginaDoSgcq",
    component: PaginaDoSgcq,
    meta: {
      publica: false,
    },
  },

  {
    path: "/prioridades",
    name: "PaginaDashboardPrioridades",
    component: PaginaDashboardPrioridades,
    meta: {
      publica: false,
    },
  },

  {
    path: "/orcamentos",
    name: "PaginaDoOrcamento",
    component: PaginaDoOrcamento,
    meta: {
      publica: false,
    },
  },

  {
    path: "/certificados",
    name: "PaginaDeCertificado",
    component: PaginaDeCertificado,
    meta: {
      publica: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((routeTo, routeFrom, next) => {
  if (!routeTo.meta.publica && !useSgcqStore().authenticated) {
    return next({ path: "/login" });
  } else {
    next();
  }
});

export default router;
